import { LoansPaths } from 'app/configs/routesConfig/loans';

import { LiabilityExpenseType } from 'constants/loanApplication';

export const generateFinancialInfoPath = ({
  applicationId,
  tab,
  tablePath,
  borrowerId,
  actionType,
  pathFrom,
  recordId,
}) => ({
  pathname: LoansPaths.applicationManagement.generatePath({
    applicationId,
    tab,
    subtab: tablePath,
    entityId: borrowerId,
    section: actionType,
    subsection: recordId,
  }),
  state: {
    pathFrom,
  },
});

export const filterClosedLiabilities = liabilities =>
  liabilities.filter(({ liabilityAccountType, unpaidBalance, liabilityExpenseType }) =>
    liabilityAccountType
      ? unpaidBalance > 0
      : liabilityExpenseType === LiabilityExpenseType.CHILD_SUPPORT,
  );
